import { render } from "./TypeItem.vue?vue&type=template&id=45a5e9a9&scoped=true&ts=true"
import script from "./TypeItem.vue?vue&type=script&lang=ts"
export * from "./TypeItem.vue?vue&type=script&lang=ts"

import "./TypeItem.vue?vue&type=style&index=0&id=45a5e9a9&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a5e9a9"]])

export default __exports__